import { InputComponentProps, ValidatingInput } from '~/components/validating-input';

const KWH_LOWER_LIMIT = 0;
const KWH_UPPER_LIMIT = 50000;

export interface EstimatedAnnualKwhProps extends InputComponentProps {
  validation?: string;
  validations?: Array<string>;
  label?: string;
}
export const EstimatedAnnualKwh = ({
  validation,
  requirements,
  validations,
  label,
  ...props
}: EstimatedAnnualKwhProps) => {
  const validate = ({ value }) => {
    const internalValidation = Number(value) > KWH_LOWER_LIMIT && Number(value) <= KWH_UPPER_LIMIT;
    const validationPatterns = validations || (validation ? [validation] : undefined);
    let externalValidation = true;
    if (validationPatterns) {
      externalValidation = !!validationPatterns.find(pattern => new RegExp(pattern!).test(value));
    }

    return internalValidation && externalValidation
      ? true
      : 'Please recheck your estimated annual kWh. If you believe your estimate to be correct, please call us at (866) 526-0083.';
  };

  return (
    <ValidatingInput
      label={label || 'Estimated annual usage (kWh)'}
      name="estimatedAnnualKwh"
      requirements={requirements || 'Example: 7614'}
      validate={validate}
      type="number"
      {...props}
      helpContent={{
        type: 'ENROLLMENT_FIELDS',
      }}
    />
  );
};
